import { HeaderLogo } from './header-logo';
import { HeaderUtilities } from './header-utilities';

/**
 * Minimal header for error pages - no navigation, just logo and user utilities
 */
export const MinimalHeader = ({
	user,
	onLogout,
}: {
	user: { name: string; role: string };
	onLogout?: () => void | Promise<void>;
}) => {
	return (
		<div className="bg-card/95 supports-[backdrop-filter]:bg-card/60 sticky top-0 z-20 border-b backdrop-blur">
			<div className="3xl:w-2/3 3xl:px-0 m-auto flex h-16 items-center px-4 lg:px-8">
				<HeaderLogo linkTo="/" />
				<HeaderUtilities user={user} onLogout={onLogout} />
			</div>
		</div>
	);
};
